import { useVirtualAssistant } from "../../context/VirtualAssistantContext";

export function useContactDetailsModal() {
  const { openContactDetails, openAddContactMenu } = useVirtualAssistant();

  const renderContactDetailsModal = () => null;

  return {
    openContactDetails,
    openAddContactMenu,
    renderContactDetailsModal,
  };
}
